import React from 'react'
import Spinner from 'react-bootstrap/Spinner'

const LoadingSpinner = () => <Spinner animation='border' variant='primary' />

export default LoadingSpinner
